var map = {
	"./ar/sound/SoundPage.vue": [
		608,
		227
	],
	"./en/sound/SoundPage.vue": [
		4841,
		841
	],
	"./fa/sound/SoundPage.vue": [
		5138,
		138
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 5848;
module.exports = webpackAsyncContext;